import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
let inflight = null;

/** Fetch AI availability once per session. AI buttons hide when disabled. */
export const useAiStatus = () => {
  const [status, setStatus] = useState(cache || { enabled: false, features: {} });
  useEffect(() => {
    if (cache) return;
    if (!inflight) {
      inflight = api
        .get("/ai/status")
        .then((r) => {
          cache = r.data;
          return r.data;
        })
        .catch(() => ({ enabled: false, features: {} }));
    }
    inflight.then((s) => setStatus(s));
  }, []);
  return status;
};
